import React from 'react';
import { useReactFlow } from '@xyflow/react';
import { useERDStore } from './erdStore';
import { NODE_TYPE_CONFIG, NODE_TYPES } from './erdConstants';

export default function ERDSidebar() {
  const addNode = useERDStore(s => s.addNode);
  const { screenToFlowPosition } = useReactFlow();

  function handleAdd(type) {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const pos = screenToFlowPosition({ x: centerX, y: centerY });
    addNode(type, { x: pos.x - 120, y: pos.y - 60 });
  }

  return (
    <div className="erd-sidebar">
      <p className="erd-sidebar-title">Add Node</p>
      {NODE_TYPES.map(type => {
        const cfg = NODE_TYPE_CONFIG[type];
        return (
          <button key={type} onClick={() => handleAdd(type)} className="erd-sidebar-btn">
            <span className="erd-sidebar-swatch" style={{ backgroundColor: cfg.headerBg, border: `1px solid ${cfg.border}` }} />
            <span>{cfg.label}</span>
          </button>
        );
      })}
      <div className="erd-sidebar-help">
        <p>Drag handles to connect nodes. Click a node or edge to edit.</p>
      </div>
    </div>
  );
}
